var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
/* eslint-disable max-len */
import axios from 'axios';
import { APIMethod } from './enums';
// URL for Online Deployments: Port Number not Required
var CARE_PORTAL_DEFAULT_URL = "".concat((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin, "/api/");
// URL for Local Deployment includes Port Number
var CARE_PORTAL_LOCAL_URL = "".concat((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.origin, "/api/");
var CARE_PORTAL_URL = window.location.hostname === 'localhost'
    ? CARE_PORTAL_LOCAL_URL
    : CARE_PORTAL_DEFAULT_URL;
var CARE_PORTAL_URL_OLD = process.env.REACT_APP_CARE_PORTAL_URL_OLD;
// This contains all the request cancel object.
var cancelRequestList = {};
export var cancelRequests = function () {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    keys.forEach(function (key) {
        if (cancelRequestList[key]) {
            cancelRequestList[key]();
            delete cancelRequestList[key];
        }
    });
};
export var cancelAllRequests = function () {
    Object.keys(cancelRequestList).forEach(function (key) {
        if (cancelRequestList[key]) {
            cancelRequestList[key](key);
            delete cancelRequestList[key];
        }
    });
};
var is5xxCode = function (code) {
    return typeof code === 'number' && code >= 500 && code <= 599;
};
var delay = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
var RETRY_DELAY_MS = 1000;
function API(params, retryCount) {
    if (retryCount === void 0) { retryCount = 0; }
    var MAX_RETRIES = 3;
    var url = params.mode
        ? "".concat(CARE_PORTAL_URL_OLD).concat(params.mode, "/").concat(params.url)
        : "".concat(CARE_PORTAL_URL).concat(params.url);
    //need to stringify params in latest axios
    var stringifyParams = {};
    if (params.params) {
        Object.keys(params === null || params === void 0 ? void 0 : params.params).forEach(function (item) {
            if ((params === null || params === void 0 ? void 0 : params.params[item]) !== null && (params === null || params === void 0 ? void 0 : params.params[item]) !== undefined) {
                stringifyParams[item] =
                    typeof (params === null || params === void 0 ? void 0 : params.params[item]) === 'string'
                        ? params.params[item]
                        : JSON.stringify(params.params[item]);
            }
        });
    }
    return axios({
        url: url,
        params: stringifyParams,
        method: params.method,
        cancelToken: new axios.CancelToken(function (c) {
            cancelRequestList[params.cancelKey] = c;
        }),
        responseType: params.responseType,
        headers: __assign({}, params.headers),
        data: params.data,
    })
        .then(function (res) {
        var _a, _b;
        var resData = (_a = res.data) !== null && _a !== void 0 ? _a : res;
        // check api res for file
        if (resData instanceof ArrayBuffer) {
            return { file: resData };
        }
        var applicationCode = resData.application_code;
        // Retry on any 5xx application_code in the response body
        if (is5xxCode(applicationCode) && retryCount < MAX_RETRIES) {
            console.warn("App code ".concat(applicationCode, " received. Retrying in ").concat(RETRY_DELAY_MS, "ms... (").concat(retryCount + 1, "/").concat(MAX_RETRIES, ")"));
            return delay(RETRY_DELAY_MS).then(function () { return API(params, retryCount + 1); });
        }
        // All retries exhausted — reject with isRetrying: false so the interceptor shows the popup
        if (is5xxCode(applicationCode) && retryCount >= MAX_RETRIES) {
            console.error("Max retries reached for app code ".concat(applicationCode, ". Giving up."));
            return Promise.reject({
                status: applicationCode,
                message: resData.message || 'Server error after multiple retries',
                isRetrying: false,
            });
        }
        return {
            applicationCode: applicationCode,
            message: resData.message,
            // Some endpoints (such as task creation) return their payload at the
            // top level instead of inside a `data` property.
            data: (_b = resData.data) !== null && _b !== void 0 ? _b : resData,
            error: resData.error,
        };
    })
        .catch(function (error) {
        var _a, _b;
        // If this is already a shaped rejection from the .then block above (max retries hit), re-throw as-is
        if ((error === null || error === void 0 ? void 0 : error.isRetrying) === false) {
            return Promise.reject(error);
        }
        var status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
        var body = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data;
        var effectiveCode = (body === null || body === void 0 ? void 0 : body.application_code) || status;
        // Retry on HTTP-level 5xx (e.g. gateway/network errors with no body)
        if (is5xxCode(effectiveCode) && retryCount < MAX_RETRIES) {
            console.warn("HTTP ".concat(effectiveCode, " received. Retrying in ").concat(RETRY_DELAY_MS, "ms... (").concat(retryCount + 1, "/").concat(MAX_RETRIES, ")"));
            return delay(RETRY_DELAY_MS).then(function () { return API(params, retryCount + 1); });
        }
        // Either retries exhausted or a non-5xx error — let the popup show
        return Promise.reject(__assign({ status: effectiveCode, message: body === null || body === void 0 ? void 0 : body.message, isRetrying: false }, error));
    });
}
function QuestionnaireAPI(params) {
    var url = params.mode
        ? "".concat(CARE_PORTAL_URL_OLD).concat(params.mode, "/").concat(params.url)
        : "".concat(CARE_PORTAL_URL).concat(params.url);
    //need to stringify params in latest axios
    var stringifyParams = {};
    if (params.params) {
        Object.keys(params === null || params === void 0 ? void 0 : params.params).forEach(function (item) {
            if ((params === null || params === void 0 ? void 0 : params.params[item]) !== null && (params === null || params === void 0 ? void 0 : params.params[item]) !== undefined) {
                stringifyParams[item] =
                    typeof (params === null || params === void 0 ? void 0 : params.params[item]) === 'string'
                        ? params.params[item]
                        : JSON.stringify(params.params[item]);
            }
        });
    }
    return axios({
        url: url,
        params: stringifyParams,
        method: params.method,
        cancelToken: new axios.CancelToken(function (c) {
            cancelRequestList[params.cancelKey] = c;
        }),
        responseType: params.responseType,
        headers: __assign({}, params.headers),
        data: params.data,
    })
        .then(function (res) {
        var resData = res === null || res === void 0 ? void 0 : res.data.content;
        // check api res for file
        if (resData instanceof ArrayBuffer) {
            return {
                file: resData,
            };
        }
        return {
            applicationCode: resData === null || resData === void 0 ? void 0 : resData.application_code,
            message: resData === null || resData === void 0 ? void 0 : resData.message,
            data: resData === null || resData === void 0 ? void 0 : resData.data,
            error: resData === null || resData === void 0 ? void 0 : resData.error,
        };
    })
        .catch(function (error) {
        console.log('error2', error);
        return Promise.reject(error);
    });
}
function UPLOAD_API(params) {
    var uninterceptedAxiosInstance = axios.create();
    return uninterceptedAxiosInstance({
        url: params.url,
        method: APIMethod.Post,
        data: params.uploadApiData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
        .then(function (res) {
        var resData = res.data;
        // check api res for file
        if (resData instanceof ArrayBuffer) {
            return {
                file: resData,
            };
        }
        return {
            applicationCode: resData.application_code,
            message: resData.message,
            data: resData.data,
            error: resData.error,
        };
    })
        .catch(function (error) {
        return Promise.reject(error);
    });
}
export { API, UPLOAD_API, QuestionnaireAPI };
